import React, { useContext, useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

import UserContext from '../../../../../contexts/UserContext';
import { fetchOwnCompanies, fetchSellers } from '../api';
import { DUSTRE_ES_CNPJ } from '../constants';
import { OrderSchemaType } from '../order.schema';

interface SteelAutofillBridgeProps {
  isEditMode: boolean;
}

/**
 * Preenche vendedor e "Meu CNPJ" na criação. Vive dentro do form porque escreve nele; ambos
 * desistem se o campo já tem valor, para nunca sobrescrever escolha do usuário.
 */
const SteelAutofillBridge: React.FC<SteelAutofillBridgeProps> = ({ isEditMode }) => {
  const { getValues, setValue } = useFormContext<OrderSchemaType>();
  const { user } = useContext(UserContext);
  // o contexto guarda a entidade da API, que traz `id`; `sub` só existe no payload do token
  const userId = user?.id || user?.sub;

  useEffect(() => {
    if (isEditMode || !userId) return;
    if (getValues('sellerId')) return;
    let active = true;
    fetchSellers()
      .then((sellers) => {
        if (!active || getValues('sellerId')) return;
        const match = (sellers || []).find((s) => Number(s.id) === Number(userId));
        if (match) {
          setValue('seller', match.name || '', { shouldDirty: false, shouldValidate: false });
          setValue('sellerId', Number(match.id), { shouldDirty: false, shouldValidate: false });
          setValue('sellerDetails', match as Record<string, any>, { shouldDirty: false, shouldValidate: false });
        }
      })
      .catch(() => undefined);
    return () => { active = false; };
  }, [isEditMode, userId, getValues, setValue]);

  useEffect(() => {
    if (isEditMode) return;
    if (getValues('supplierId')) return;
    let active = true;
    fetchOwnCompanies()
      .then((companies) => {
        if (!active || getValues('supplierId')) return;
        const match = (companies || []).find(
          (c) => (c.cnpj || '').replace(/\D/g, '') === DUSTRE_ES_CNPJ,
        );
        if (match) {
          setValue('supplier', match.companyName || '', { shouldDirty: false, shouldValidate: false });
          setValue('supplierId', Number(match.id), { shouldDirty: false, shouldValidate: false });
          setValue('supplierDetails', match as Record<string, any>, { shouldDirty: false, shouldValidate: false });
        }
      })
      .catch(() => undefined);
    return () => { active = false; };
  }, [isEditMode, getValues, setValue]);

  return null;
};

export default SteelAutofillBridge;
